'use strict';
angular.module('weiboToBeCompiledRouterModule', [])
    . config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $stateProvider.state('front.editctr.weibo.waitcompiled', {
            url: '/waitcompiled?wbchannelid&channelid',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/weibo/toBeCompiled/toBeCompiled_tpl.html',
                    controller: 'weiboToBeCompiledCtrl'
                }
            }
        }).state('weiboedit', {
            url: '/weiboedit?wbmetadataid&wbchannelid&wbplatform&isawaitrevise', // isawaitrevise->待修订
            views: {
                '': {
                    templateUrl: './editingCenter/weibo/toBeCompiled/editPageForWeibo/editPageForWeibo_tpl.html',
                    controller: 'editPagrForWeiboCtrl'
                }
            }
        }).state('weiboheadlinesedit', {
            url: '/weiboheadlinesedit?wbmetadataid&wbchannelid&wbplatform&isawaitrevise', // isawaitrevise->待修订
            views: {
                '': {
                    templateUrl: './editingCenter/weibo/toBeCompiled/weiboHeadlines/index.html',
                    controller: 'weiboHeadlinesCtrl'
                }
            }
        });
    }]);
